module.exports = __webpack_public_path__ + "img/battery.9cfba687.png";